export default "__VITE_ASSET__mQ_$rDEd__"